import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 614px;
  align-items: center;
`;

export const SearchBarWrapper = styled.div`
  width: 501px;
  height: 38px;
  position: relative;
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.borders.searchBar};
  background-color: ${({ theme }) => theme.backgrounds.searchBar};
  align-items: center;
`;
